import { useIntersectionObserver } from 'hooks/useIntersectionObserver/useIntersectionObserver'
import { useProductListAnalyticsProvider } from 'product-list/context/ProductListAnalyticsProvider/useProductListAnalyticsProvider'
import { useProductListProvider } from 'product-list/context/ProductListProvider/useProductListProvider'
import { type RefObject, useCallback, useEffect, useLayoutEffect } from 'react'

export const VIRTUAL_ITEM_CLASS = 'virtual-item'
export const VIRTUAL_LIST_CLASS = 'virtual-list'

export function useVirtualPages(
	itemElement: RefObject<Element | null>,
	total: number,
	perPage: number
) {
	const { count, setCount } = useProductListProvider()

	const { onListEndWasReached } = useProductListAnalyticsProvider()

	const next = useCallback(() => {
		setCount((prev) => {
			if (prev >= total) {
				return prev
			}
			return prev + perPage
		})
	}, [perPage, setCount, total])

	const entry = useIntersectionObserver(itemElement, {
		rootMargin: '0px 0px 100% 0px',
		threshold: [0, 1],
	})

	useEffect(() => {
		if (count >= total) {
			onListEndWasReached?.()
		}
	}, [count, total, onListEndWasReached])

	useEffect(() => {
		if (entry?.isIntersecting) {
			next()
		}
	}, [entry, next])

	useLayoutEffect(() => {
		window.history.scrollRestoration = 'manual'
	}, [])
}
